import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Image/Logo.jpg";
import { logoutAction } from "../../Actions/login";
import { useDispatch } from "react-redux";
import UserLogo from "../../Image/user.jpeg";
import { sendSharedData } from "../../Actions/SharedDataAction/SharedDataAction";
const Navbar = ({ userAuth }) => {
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logoutAction());
  };
  const positions = [
    {
      id: 1,
      name: "HR Zad",
      route: "http://localhost:3001",
    },

    {
      id: 6,
      name: "Media Zad",
      route: "http://localhost:3001",
    },
  ];

  const navigate = useNavigate();
  const [previligeId, setPreviligeId] = useState([]);
  useEffect(() => {
    let tempPrivilgeId = [];
    userAuth?.user_info?.privilges?.map((previlige) => {
      tempPrivilgeId.push(previlige.position_id);
      // console.log(tempPrivilgeId)
      setPreviligeId(tempPrivilgeId);
    });
  }, [userAuth]);
  return (
    <nav className="bg-white z-50">
    
    <div className=" px-2  sm:px-6 lg:px-3">
      <div className="relative flex h-16 items-center justify-between">
        <div className="absolute inset-y-0 left-0 flex items-center sm:hidden"></div>
        <div className="   sm:items-stretch sm:justify-start">
          <div className="flex flex-shrink-0 items-center">
            <Link to={"/"}>
              <img
                className="h-14 w-auto hover:animate-pulse cursor-pointer"
                src={Logo}
                alt="Your Company"
              />
            </Link>
          </div>
        </div>
        <div className="absolute z-50 inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
          {/* drop down menu */}
          <div className="relative ml-3">
            <div>
              <button
                type="button"
                onClick={() => setIsOpenSetting(!isOpenSetting)}
                className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                id="user-menu-button"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span className="absolute -inset-1.5"></span>
                <span className="sr-only">Open user menu</span>
                {userAuth?.user_profile_cv ? (
                  <img
                    className="h-10 w-10 rounded-full object-cover"
                    src={
                      userAuth?.user_profile_cv &&
                      userAuth?.user_profile_cv?.image
                    }
                    alt=""
                  />
                ) : (
                  <img
                    className="h-10 w-10 rounded-full object-cover"
                    src={UserLogo}
                    alt=""
                  />
                )}
              </button>
            </div>
            {isOpenSetting && (
              <div
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button"
              >
                <Link
                  to={"/profile"}
                  onClick={() => setIsOpenSetting(false)}
                  className="block px-4 py-2 text-sm text-gray-700"
                  role="menuitem"
                  id="user-menu-item-0"
                >
                  Your Profile
                </Link>

                <button
                  href="#"
                  className="block px-4 py-2 text-sm text-gray-700"
                  role="menuitem"
                  id="user-menu-item-2"
                  onClick={handleLogout}
                >
                  Sign out
                </button>
                <hr />

                {positions?.map((position, index) => {
                  return (
                    <>
                      {previligeId.includes(position.id) && (
                        <button
                          key={index}
                          href="#"
                          className="block font-bold px-4 hover:bg-gray-200 w-full duration-500 text-left py-2 text-sm text-gray-700"
                          role="menuitem"
                          id="user-menu-item-2"
                          onClick={() => {
                            navigate(position.route);
                          }}
                        >
                          {position.name}
                        </button>
                      )}
                    </>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </nav>
  );
};

export default Navbar;
